Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var setPath = function setPath(_ref, value) {
  var _ref2 = _toArray(_ref),
      key = _ref2[0],
      next = _ref2.slice(1);

  var obj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var type = Number.isNaN(Number(key + 1)) ? {} : [];
  var nextObj = Object.assign(type, _extends({}, obj, _defineProperty({}, key, next.length === 0 ? value : setPath(next, value, obj[key]))));

  // Todo: make this better!
  if (nextObj[key] === undefined || nextObj[key] === Object(nextObj[key]) && Object.keys(nextObj[key]).length === 0) {
    delete nextObj[key];
  }

  return nextObj;
};

exports['default'] = function (path, value, obj) {
  return setPath(path.split('.'), value, obj);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/formera/lib/helpers/setIn.js
// module id = 209
// module chunks = 0